// App version — increment with each deployment
const APP_VERSION = '2.0';
export default APP_VERSION;
